import React from 'react';
import Button from '../../UI/button';

const ForgotYourPasswordPage = () => {
  return (
    <>
      <div className='gradient-bg-login gradient-bg-decoration'></div>
      <div
        className='overflow-y-auto'
        style={{ height: 'calc(100vh - var(--header-height))' }}
      >
        <div className='forgot-your-password'>
          <div className='forgot-your-password-container'>
            <h2>Forgot your password?</h2>
            <p className='forgot-your-password-description'>
              We’ll send you a link to reset your password to the email address
              associated with your account.
            </p>
            <p className='forgot-your-password-alert'>
              Please check your inbox and follow the instructions in the email.
            </p>
            <div className='forgot-your-password-resend-email'>
              <p className='forgot-your-password-resend-email-title'>
                Didn’t receive the email?
              </p>
              <p className='forgot-your-password-resend-email-subtitle'>
                Make sure to check your spam, or try resending the link.
              </p>
              <Button
                variant='dark'
                px={20}
              >
                Resend Email
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotYourPasswordPage;
